export enum MessageButtonType {
  Link = 'Link'
}
